import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchRate,
  fetchRates,
} from "../../actions/callrecorder/ratesActions";

export interface RateInterface {
  url: string;

  id: number;
  provider_id: number;
  currency_id: number | null;
  prefix: string;
  prefix_len: number;
  src_prefix: string | null;
  src_prefix_len: number;
  cost_per_min: string;
  raw_cost: string | null;
  iso: string | null;
  notes: string | null;
  last_synced_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<RateInterface>();

const slice = createSlice({
  name: 'rates',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchRates.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchRates.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.rates;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchRates.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchRate.fulfilled, (state, action) => {
        const record = Object.values(action.payload.rate)[0];
        state.entities[record.id] = record;
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectRateById,
  selectIds: selectRateIds,
  selectEntities: selectRateEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.rates);
